import "./SummarySubform.scss";

import { Card, Divider, Grid, Typography } from "@material-ui/core";
import { InvestmentField, InvestmentInputTypeKey } from "common/components/input/fields";
import { SubformProps } from "common/components/SubformProps";
import { CreateInvestmentManageable } from "common/store/investment/types";
import { SaleManageable } from "common/store/sale/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { CustomerInfo } from "shared/customer-info/CustomerInfo";

interface SummarySubformProps extends SubformProps<CreateInvestmentManageable> {
  sale: SaleManageable;
}

export const SummarySubform = (props: SummarySubformProps) => {
  // Hooks
  const { t } = useTranslation();

  const {
    values,
    sale,
  } = props;

  return (
    <Card>
      <Grid container direction="column" spacing={6}>
        <Grid item xs={12}>
          <Typography className="subtitle--big--inner" color="textSecondary">
            {t("Contract details")}
          </Typography>

          <Divider />

          <Grid container direction="column" spacing={3}>
            <Grid container direction="row" item xs={12}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" color="textSecondary">
                  {t("Product")}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" color="textSecondary">
                  {sale.title}
                </Typography>
              </Grid>
            </Grid>

            <Grid item />

            <Grid container direction="row" item xs={12}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" color="textSecondary">
                  {t("Subscription amount")}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" color="textSecondary">
                  {values.amountShares} €
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Divider className="black-divider"/>
        </Grid>

        <Grid item xs={12}>
          <Typography className="subtitle--big--inner" color="textSecondary">
            {t("Personal details")}
          </Typography>

          <Divider />

          <CustomerInfo />

          <Divider className="black-divider"/>
        </Grid>

        <Grid item xs={12}>
          <Typography className="subtitle--big--inner" color="textSecondary">
            {t("Acknowledgement of receipt")}
          </Typography>

          <Divider/>

          <Typography variant="body1" color="textSecondary">
            {t("I hereby acknowledge that I have received, downloaded or printed the following documents in electronic form, and that I have read and understood them in good time before submitting this declaration of subscription")}
          </Typography>

          <Grid container direction="column" item xs={12}>
            {Array.from(values.documents || []).map((
              _: boolean, index: number
            ) =>
              <Grid item xs={12} key={index}>
                <InvestmentField
                  id={"documents" as InvestmentInputTypeKey}
                  index={index}
                  label={sale.documents?.[index]?.id}
                  {...props}
                />
              </Grid>)}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};
